import PropTypes from 'prop-types';
import React from 'react'

import { Pencil, Plus, Trash } from 'lucide-react';
import { FormSection, Select, Row, Col, FormGroup, Label, Input, Switch, Button, DefaultTooltip, SimpleAlert, ButtonGroup, Separator, DefaultTable, ColorPickerInputGroup, ButtonIcon } from 'twyne-new.ui';

import CodeEditor from '@Components/form/CodeEditor';

import ConsentDBAs from '../ConsentDBAs';

class TcpaQuestionForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tcpaquestion: null,
      customFields: null,
      customFieldSelected: null,
    }
  }

  CONSENT_POSITION_TYPES = [{
    label: 'After Answers',
    value: 'after',
  }, {
    label: 'Before Answers',
    value: 'before',
  }]

  get allowBidSelection() {
    return this.props.integration?.configuration?.allowBidSelection || false
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
    this.updateOptions(this.state.customFieldSelected);
  }

  updateCustomFields = ({ integrationData: { extraFields, tcpaquestion } }) => {
    const customFields = (extraFields || []).map(({
      id, group, type, options, date_format, key: value, name: label,
    }) => ({
      id, group, type, options, date_format, value, label: `${label} (${type})`,
    }));
    const customFieldSelected = customFields.find(field => tcpaquestion.cfid === field.value) || {};
    tcpaquestion.cfid_number = tcpaquestion.cfid_number || customFieldSelected.id;

    this.state = {
      tcpaquestion,
      customFields,
      customFieldSelected,
    };
  }
  makeDefaultAnswer = answer => ({
    key: "",
    answer: "",
    fontcolor: "255,255,255,1",
    color: "113,113,113,1", ...answer,
  })

  addPostData = (answers, answer) => {
    answers.push(this.makeDefaultAnswer(answer));
    return answers
  }

  updateOptions = cf => {
    const { tcpaquestion } = this.state
    if (!cf) return;
    const isSelect = cf.type === 'select';
    const isBoolean = cf.type === 'boolean';

    if (isBoolean || isSelect) {
      if (isSelect) {
        const { answers } = tcpaquestion;
        const currentKeyAnswers = answers.map(({ key }) => key);
        const newKeysAnswers = cf.options.map(({ value: key }) => key);
        answers.forEach((answer, idx) => {
          !newKeysAnswers.includes(answer.key) && this.handleClickRemovePostData(idx);
        });
        cf.options.forEach(({ value: key, label: answer }) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData({ key, answer });
        });
      }
      if (isBoolean) {
        const { answers } = tcpaquestion;
        const options = [{ key: "true", answer: "Yes" }, { key: "false", answer: "No" }];
        const currentKeyAnswers = answers.map(({ key }) => key);
        answers.forEach(({ key }, idx) => {
          !["true", "false"].includes(key) && this.handleClickRemovePostData(idx)
        });
        options.forEach(({ key, answer }, idx) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData(this.makeDefaultAnswer({ key, answer }))
        });
        return;
      }
      return;
    }
    tcpaquestion.answers = tcpaquestion.answers || [];
  }

  handleChangeAnswerInput = (idx, key, value) => {
    if (this.state.customFieldSelected.type === 'input' && !['color', 'fontcolor'].includes(key)) {
      value = value.replace(/[}{,()$]/g, '')
    }
    const { answers } = this.state.tcpaquestion;
    if (!answers[idx]) {
      return this.handleChangeSkipAnswer(key, value)
    }
    answers[idx][key] = value;
    this.props.onChange('answers', answers);
  }

  handleClickRemovePostData = idx => {
    const { answers } = this.state.tcpaquestion
    answers.splice(idx, 1);
    this.props.onChange('answers', answers)
  }

  handleClickAddPostData = answer => {
    this.props.onChange('answers', this.addPostData(this.state.tcpaquestion.answers, answer))
  }

  handleEnableTrustedForm = e => {
    const { checked } = e.target

    if (checked) {
      if (this.state.tcpaquestion.cfid === null || this.state.tcpaquestion.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.tcpaquestion.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }
  }

  handleEnableLeadId = e => {
    const { checked } = e.target

    if (checked) {
      if (this.state.tcpaquestion.cfid === null || this.state.tcpaquestion.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.tcpaquestion.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }
  }
  handleCustomFieldEdit = cfid => {
    this.props.onCustomFieldClick({
      cfid,
      customFieldOpen: true,
    })
  }

  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }

  handleChangeSkip = ({ target: { checked } }) => {
    this.handleEnable('skipOption').call(this, { target: { checked } })
    const skipOpt = checked ? { key: '$skip', answer: 'Skip', fontcolor: "255,255,255,1", color: "113,113,113,1", disabled: true } : null
    this.props.onChange('skipAnswer', skipOpt)
  }

  handleChangeSkipAnswer = (key, value) => {
    const { skipAnswer } = this.state.tcpaquestion
    skipAnswer[key] = value
    this.props.onChange('skipAnswer', skipAnswer)
  }
  handleEnableMultipleAnswers = evt => {
    this.props.onChange('manualSubmit', false)
    this.props.onChange('required', false)
    this.handleEnable('isMultipleAnswers').call(this, evt)
  }

  handleEnableManualSubmit = evt => {
    this.handleEnable('manualSubmit').call(this, evt)
    evt.target.checked && this.props.onCustomFieldClick({ hideHostedSubmit: false })
  }

  handleEnableRequiredSubmit = evt => {
    this.handleEnable('required').call(this, evt)
  }

  handleChangeCustomField = cf => {
    const { tcpaquestion } = this.state
    const cfid = cf ? cf.value : null
    this.props.onChange('cfid_number', cf ? `${cf.id}` : null);
    this.props.onChange('cfid', cfid)
    tcpaquestion.answers = []
    this.updateOptions(cf)
    this.props.onChange('answers', tcpaquestion.answers)
    this.props.onChange('isMultipleAnswers', false)
    this.props.onChange('manualSubmit', false)
    const { leadid, trustedform } = tcpaquestion
    leadid && this.props.onChange('leadid_cfid', `${cfid}_leadid`)
    trustedform && this.props.onChange('trustedform_cfid', `${cfid}_trustedform`)
  }

  renderAnswerTypes = () => {
    const { tcpaquestion } = this.state
    const options = tcpaquestion.answers = tcpaquestion.answers || [];

    const { handleChangeAnswerInput, handleClickRemovePostData } = this;
    const oAProps = {
      options,
      handleChangeAnswerInput,
      disabled: this.props.disabled,
      handleClickRemovePostData,
      skipAnswer: tcpaquestion.skipAnswer,
      isMult: tcpaquestion.isMultipleAnswers,
      skipOption: tcpaquestion.skipOption,
    };
    switch (this.state.customFieldSelected.type) {
      case 'select':
      case 'boolean':
        oAProps.keysDisabled = true;
        break;
      case 'integer':
        oAProps.keyInputType = 'number';
        break;
      case 'date':
        oAProps.keyInputType = 'date';
        break;
      default:
        break;
    }
    return <OptionsAnswer {...oAProps} />
  }

  render() {
    return (
      <div key={this.state.tcpaquestion.cfid || ''}>
        <Row>
          <Col size="6">
            <FormGroup>
              <Label>Custom Field</Label>
              <Select name="type" value={this.state.tcpaquestion.cfid || ''} options={this.state.customFields}
                onChange={this.handleChangeCustomField} disabled={this.props.disabled} />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>&nbsp;</Label>
              <ButtonGroup>
                <Button color="accent" disabled={this.props.disabled} onClick={() => this.handleCustomFieldEdit()}>
                  <Plus size={14} />
                  Add
                </Button>
                <DefaultTooltip content='Edit' triggerProps={{ asChild: true }}>
                  <Button variant='outline' color="accent" disabled={this.props.disabled || !this.state.tcpaquestion.cfid_number} onClick={() => this.handleCustomFieldEdit(this.state.tcpaquestion.cfid_number)}>
                    <Pencil size={14} />
                  </Button>
                </DefaultTooltip>
              </ButtonGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={e => this.handleEnableTrustedForm(e)}
                checked={this.state.tcpaquestion.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={e => this.handleEnableLeadId(e)}
                checked={this.state.tcpaquestion.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.tcpaquestion.alwaysShow || false}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Consent text</Label>
              <Switch
                onChange={this.handleEnable('consentTextActive')}
                checked={this.state.tcpaquestion.consentTextActive || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.tcpaquestion.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          {this.state.customFieldSelected.type !== "boolean" && <Col size='2'>
            <FormGroup>
              <Label>Multiple answers</Label>
              <Switch
                onChange={this.handleEnableMultipleAnswers}
                checked={this.state.tcpaquestion.isMultipleAnswers}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>}
          {this.state.tcpaquestion.isMultipleAnswers ? <Col size='2'>
            <FormGroup>
              <Label>Required</Label>
              <Switch
                onChange={this.handleEnableRequiredSubmit}
                checked={this.state.tcpaquestion.required || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col> : <Col size='2'>
            <FormGroup>
              <Label>Manual Submit</Label>
              <Switch
                onChange={this.handleEnableManualSubmit}
                checked={this.state.tcpaquestion.manualSubmit || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          }
          {!this.state.tcpaquestion.isMultipleAnswers && <Col size="2">
            <FormGroup>
              <Label>
                Skip option
              </Label>
              <Switch
                onChange={this.handleChangeSkip}
                checked={this.state.tcpaquestion.skipOption || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>}
          <Col size='2'>
            <FormGroup>
              <Label>Save Consent Text</Label>
              <Switch
                onChange={this.handleEnable('saveConsentText')}
                checked={this.state.tcpaquestion.saveConsentText || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>Question</Label>
              <CodeEditor
                resizable
                height="100px"
                name="question"
                value={this.state.tcpaquestion.question || ''}
                onChange={value => this.props.onChange('question', value)}
                disabled={this.props.disabled}
                width="100%"
              />
            </FormGroup>
          </Col>
          <Col size="12">
            <Separator />
          </Col>
          <Col size="12" className='flex justify-between items-center'>
            <FormSection >
              Answers
            </FormSection>
            <DefaultTooltip
              content={!['integer', 'input', 'date'].includes(this.state.customFieldSelected.type) && 'Custom fields needs to be of type integer, input, or date to add answers.'}>
              <Button
                disabled={!['integer', 'input', 'date'].includes(this.state.customFieldSelected.type) || this.props.disabled}
                color="accent"
                size="sm"
                onClick={() => this.handleClickAddPostData()}
              >
                <Plus size={14} />
                Add
              </Button>
            </DefaultTooltip>
          </Col>
          <Col size="12">
            {this.renderAnswerTypes()}
          </Col>
          {this.state.tcpaquestion.consentTextActive && <>
            {this.allowBidSelection ? <>
              <Col size="12">
                <SimpleAlert color="warning">
                  This integration requires using the helpers to render DBA's checkbox in your consent text.
                </SimpleAlert>
              </Col>
            </> : null}

            <Col size='12'>
              <FormGroup>
                <Label className='flex justify-between items-center'>
                  Consent text
                  {this.allowBidSelection ? <ConsentDBAs
                    data={this.state.tcpaquestion.dbas}
                    onChange={data => this.props.onChange('dbas', data)}
                  /> : null}
                </Label>
                <CodeEditor
                  name="consentText"
                  value={this.state.tcpaquestion.consentText || ''}
                  onChange={value => this.props.onChange('consentText', value)}
                  disabled={this.props.disabled}
                  resizable
                  height="100px"
                />
              </FormGroup>
            </Col>
            <Col size="12">
              <FormGroup>
                <Label>Consent text position</Label>
                <Select
                  value={this.state.tcpaquestion.consentPosition || this.CONSENT_POSITION_TYPES[0]}
                  options={this.CONSENT_POSITION_TYPES}
                  onChange={({ value }) => this.props.onChange('consentPosition', value)}
                  disabled={this.props.disabled}
                />
              </FormGroup>
            </Col>
          </>}
        </Row>
      </div>
    );
  }
}
TcpaQuestionForm.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func,
}
const OptionsAnswer = ({ options, keysDisabled, keyInputType, handleChangeAnswerInput, handleClickRemovePostData, disabled, skipAnswer, skipOption }) => {
  const columns = [
    {
      dataField: 'key',
      text: 'Key',
      formatter: (value, row, index) => <Input
        type={keyInputType}
        disabled={keysDisabled || disabled || value === '$skip'}
        value={value}
        onChange={e => handleChangeAnswerInput(index, 'key', e.target.value)}
        placeholder="Key"
      />
      ,
    },
    {
      dataField: 'answer',
      text: 'Answer',
      formatter: (value, row, index) => <Input
        value={value}
        disabled={disabled}
        onChange={e => handleChangeAnswerInput(index, 'answer', e.target.value)}
        placeholder="Answer"
      />
      ,
    },
    ...!disabled ? [
      {
        dataField: 'color',
        text: '',
        className: 'w-8',
        formatter: (value, row, index) => <DefaultTooltip side="bottom" content='Button Background Color' triggerProps={{ asChild: true }}>
          <ColorPickerInputGroup
            value={value}
            onChange={value => handleChangeAnswerInput(index, 'color', value?.rgbaParsed.replace('rgba(', '').replace(')', ''))}
            components={['picker', 'preview']}
          />
        </DefaultTooltip>
        ,
      },
      {
        dataField: 'fontcolor',
        text: '',
        className: 'w-8',
        formatter: (value, row, index) => <DefaultTooltip side="bottom" content='Button Font Color' triggerProps={{ asChild: true }}>
          <ColorPickerInputGroup
            value={value}
            onChange={value => handleChangeAnswerInput(index, 'fontcolor', value?.rgbaParsed.replace('rgba(', '').replace(')', ''))}
            components={['picker', 'preview']}
          />
        </DefaultTooltip>
        ,
      },
    ] : [],
    ...!keysDisabled ? [
      {
        dataField: '',
        text: '',
        className: 'w-8',
        formatter: (_, row, index) => <ButtonIcon content='Delete' onClick={() => handleClickRemovePostData(index)} disabled={disabled}>
          <Trash size={16} />
        </ButtonIcon>
        ,
      },
    ] : [],
  ]

  return (
    <DefaultTable
      data={skipOption ? [...options, skipAnswer] : options}
      columns={columns}
      noDataIndication={() => 'No answers to show.'}
      className='max-h-[30vh] overflow-y-auto'
    />
  )
}

export default TcpaQuestionForm;
